import { db_user } from "../firestore_user";

export const BANK_ACCOUNT_FIELDS = [
  "ac_name",
  "ac_number",
  "ac_bank",
  "ifsc",
  "pan",
];

/**
 * @param {object | null | undefined} project - Firestore project document data
 * @returns {boolean}
 */
export function hasBankAccountSubmitted(project) {
  if (!project) return false;
  const license = project.distributionLicense;
  return Boolean(license && String(license.ac_number || "").trim());
}

/**
 * Save bank fields on the legacy `distributionLicense` object (same as contract form).
 * @param {string} projectId
 * @param {{ ac_name: string, ac_number: string, ac_bank: string, ifsc: string, pan: string }} data
 */
export async function saveProjectBankAccount(projectId, data) {
  const id = (projectId || "").trim();
  if (!id) {
    throw new Error("Missing project");
  }

  const payload = {
    ac_name: String(data.ac_name || "").trim(),
    ac_number: String(data.ac_number || "").trim(),
    ac_bank: String(data.ac_bank || "").trim(),
    ifsc: String(data.ifsc || "")
      .trim()
      .toUpperCase(),
    pan: String(data.pan || "")
      .trim()
      .toUpperCase(),
  };

  if (BANK_ACCOUNT_FIELDS.some((key) => !payload[key])) {
    throw new Error("All bank account fields are required");
  }

  const ref = db_user.collection("projects").doc(id);

  await db_user.runTransaction(async (tx) => {
    const snap = await tx.get(ref);
    if (!snap.exists) {
      throw new Error("Project not found");
    }
    if (hasBankAccountSubmitted(snap.data())) {
      throw new Error(
        "Bank account details have already been submitted and cannot be changed."
      );
    }
    const existing = snap.data().distributionLicense || {};
    tx.update(ref, {
      distributionLicense: {
        ...existing,
        ...payload,
      },
    });
  });

  return payload;
}
